import Cropper from "cropperjs";
import { fabric } from "fabric";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import "./assets/css/normalize.scss";
import Confirmation from "./common/Confirmation";
import Button from "./components/Button";
import CropOption from "./components/CropOption";
import FabricCanvas from "./components/FabricCanvas";
import FramePanel from "./components/FramePanel";
import Shapes from "./components/Shapes";
import ToolPanel from "./components/ToolPanel";
import Toolbar from "./components/Toolbar";
import UploadSettings from "./components/UploadSettings";
import { isImage } from "./utils/CropUtils";
import { Icons } from "./utils/Icons";
import "./utils/Override";
import { CANVAS_HEIGHT, CANVAS_WIDTH } from "./utils/constant";
import {
    generateCanvasCount,
    handleBringBack,
    handleBringFwd,
    handleDuplicate,
    handleGroup,
    handleUngroup,
    isToolRequired,
    removeUnwantedText,
    sortObjectByDate
} from "./utils/customUtil";
import { handleDrawingModes } from "./utils/handleDrawingModes";
import translator from "./utils/translation";
import { redo, undo } from "./utils/undoRedo";
import { applyZoom, zoomWithMouse } from "./utils/zoom";

import { ReactComponent as IconCrop } from './assets/icons/custom/Crop.svg'
import { ReactComponent as DropIcon } from './assets/icons/custom/DownIcon.svg'
import { ReactComponent as IconFrame } from './assets/icons/custom/Frame.svg'
import { ReactComponent as IconPath } from './assets/icons/custom/Pen.svg'
import { ReactComponent as IconBrush } from './assets/icons/custom/Pencil.svg'
import { ReactComponent as IconText } from './assets/icons/custom/Type.svg'
import { ReactComponent as IconCursor } from './assets/icons/leftbar/Move.svg'

let initCropper;
window.globalColor = "#000000";
window.textConfiguration = {
    fontWeight: "",
    fontStyle: "",
    underline: false,
    fontSize: 20,
    fill: "#000",
    backgroundColor: "#fff",
    borderColor: "#000"
};
const NitexEditor = forwardRef(
    (
        {
            requiredTools,
            listOfCanvasData = {},
            removeDocumentById,
            uploadDocument,
            setActiveToolName,
            setHasAnyChange,
            listOfImages,
            removeArtBoard,
            addNewPost,
            memberList,
            commentNumberSerial,
            userInfo,
            artBoardWiseImage,
            listOfAttachments,
            listOfComments,
            pinnedImages,
            reArrangeCanvasHandler,
            onSetActiveTab,
            selectedTab,
            disableCanvas
            //   pasteArtBoardData
        },
        ref
    ) => {
        const [activeTool, setActiveTool] = useState("select");
        const [drawColor, setDrawColor] = useState("#000000");
        const [canvas, setCanvas] = useState();
        const [activeSelection, setActiveSelection] = useState(null);
        const [zoom, setZoom] = useState(1);
        const [selectedObj, setSelectedObj] = useState({});
        const [canvasList, setCanvasList] = useState({});
        const [activeShape, setActiveShape] = useState("rectangle");
        const [activeLine, setActiveLine] = useState("lineArrow");
        const [activeCommentType, setActiveCommentType] = useState("");
        const [history, setHistory] = useState({ index: null, states: [] });
        const [activeCanvasId, setActiveCanvasId] = useState();
        const [prevCanvasId, setPrevCanvasId] = useState();
        const [isMarkToolRelease, setIsMarkToolRelease] = useState(false);
        const [commentCanvasId, setCommentCanvasId] = useState(false);
        const [commentPositionNumber, setCommentPositionNumber] = useState(null);
        const [imageList, setImageList] = useState([]);
        const [docList, setDocList] = useState([]);
        const [droppedImage, setDroppedImage] = useState([]);
        const [removedCanvasIds, setRemoveCanvasId] = useState([]);
        const [canvasCount, setCanvasCount] = useState(null);
        const canvasRef = useRef({});
        const selectionRef = useRef(null);
        const [openModal, setOpenModal] = useState(false);
        const [tmpTabName, setTmpTabName] = useState(null);
        const [isShapesOpen, setIsShapesOpen] = useState(true);
        const maxHistory = 10000;
        const [activeDropdown, setActiveDropdown] = useState("");
        const [isActiveDropdown, setIsActiveDropdown] = useState(false);

        // useEffect(() => {
        //     // Function to merge new artBoardWiseImage data with the existing accumulated data
        //     const mergeArtBoardData = (newData, existingData) => {
        //         // Assuming newData and existingData are objects with artboard IDs as keys
        //         const mergedData = { ...existingData }

        //         Object.keys(newData).forEach((key) => {
        //             if (mergedData[key]) {
        //                 // If the artboard already exists, you might want to append or merge deeper data
        //                 // This example simply appends new items to the existing array
        //                 // Adjust based on your specific data structure and requirements
        //                 mergedData[key].imageList = [
        //                     ...mergedData[key].imageList,
        //                     ...newData[key].imageList
        //                 ]
        //             } else {
        //                 // If the artboard doesn't exist, add it directly
        //                 mergedData[key] = newData[key]
        //             }
        //         })

        //         return mergedData
        //     }

        //     // Merge the new artBoardWiseImage props with the accumulated state data
        //     setAccumulatedArtBoardImages((prevImages) =>
        //         mergeArtBoardData(artBoardWiseImage, prevImages)
        //     )
        // }, [artBoardWiseImage])

        useEffect(() => {
            if (document.body.clientWidth < 1300) {
                localStorage.setItem("isMobileDevice", "true");
            } else {
                localStorage.setItem("isMobileDevice", "false");
            }
        }, []);

        useEffect(() => {
            window.commentNumber = commentNumberSerial;
        }, [commentNumberSerial]);

        const generateCanvasId = () => {
            return Date.now();
        };

        useEffect(() => {
            let finalCanvasList = { ...canvasRef.current };
            let lastCanvasId = "";
            let newCanvasCount = 0;
            if (Object.keys(listOfCanvasData).length > 0) {
                const sortedCanvas = sortObjectByDate(listOfCanvasData);
                finalCanvasList = { ...finalCanvasList, ...sortedCanvas };
                lastCanvasId = Object.keys(sortedCanvas).pop(); // Gets the last key as the current last canvas id
                newCanvasCount = generateCanvasCount(lastCanvasId); // Assume this generates a count based on the lastCanvasId
                setHistory(
                    listOfCanvasData[Object.keys(sortedCanvas)[0]].canvasHistory
                );
            }

            if (
                artBoardWiseImage &&
                Object.keys(artBoardWiseImage)?.length > 0
            ) {
                let id = lastCanvasId
                    ? parseInt(lastCanvasId) + 1000
                    : generateCanvasId();
                for (const item in artBoardWiseImage) {
                    console.log("Item:", item);
                    while (
                        finalCanvasList.hasOwnProperty(item) ||
                        finalCanvasList.hasOwnProperty(id.toString())
                        ) {
                        id += 1000; // Adjust ID to avoid overwriting
                    }
                    finalCanvasList[item] = {
                        isModified: true,
                        canvasName: "Untitled",
                        canvasData: {},
                        canvasLeft: 90,
                        serial: id,
                        canvasUsedWidth: 0,
                        canvasHistory: { index: null, states: [] }
                    };
                    id += 1000; // Prepare ID for the next item
                }
                newCanvasCount += Object.keys(artBoardWiseImage).length; // Update canvas count with additional canvases
            }

            if (Object.keys(finalCanvasList).length === 0) {
                const id = generateCanvasId();
                finalCanvasList[id] = {
                    isModified: false,
                    canvasName: "Untitled",
                    canvasData: {},
                    serial: id,
                    canvasLeft: 90,
                    canvasUsedWidth: 0,
                    canvasHistory: { index: null, states: [] }
                };
                newCanvasCount = id; // Assuming generateCanvasId generates a numeric ID that can serve as a count
            }

            canvasRef.current = finalCanvasList;
            setCanvasList(finalCanvasList);
            setCanvasCount(newCanvasCount);
            //TODO listOfCanvasData
        }, [artBoardWiseImage]);

        useEffect(() => {
            if (listOfImages) {
                setImageList(listOfImages);
            }
        }, [listOfImages]);

        useEffect(() => {
            if (listOfAttachments) {
                setDocList(listOfAttachments);
            }
        }, [listOfAttachments]);

        useEffect(() => {
            selectionRef.current = activeSelection;

            if (prevCanvasId && activeCanvasId) {
                canvasList[prevCanvasId]?.canvasData
                    ?.discardActiveObject()
                    ?.requestRenderAll();
                setPrevCanvasId(null);
            }

            if (!activeSelection) return;
            if (
                (activeTool !== "mark" || activeTool !== "singlePointMark") &&
                activeTool !== "textbox"
            ) {
                setActiveTool("select");
            }

            // scroll to top in tool panel
            document.querySelector(".toolpanel .holder").scrollTop = 0;
        }, [activeSelection]);

        useEffect(() => {
            if (disableCanvas) {
                for (const item in canvasList) {
                    canvasList[item]?.canvasData
                        ?.discardActiveObject()
                        ?.requestRenderAll();
                }
                setActiveTool("");
            }
        }, [disableCanvas]);

        useEffect(() => {
            if (!canvas) return;
            if (setActiveToolName !== undefined) {
                setActiveToolName(activeTool);
            }

            if (activeTool !== "select") {
                canvas?.discardActiveObject().requestRenderAll();
                canvas.calcOffset();
            }

            handleDrawingModes(canvas, activeTool);
        }, [canvas, activeTool]);

        useEffect(() => {
            if (!canvas) return;
            const textAreaLength = document.querySelectorAll(
                "textarea:focus, input:focus"
            ).length;
            const keyShortCuts = (e) => {
                const key = e.which || e.keyCode;
                //   console.log('Key:', key)
                if (key === 27) {
                    e.preventDefault();
                    removeUnwantedText(canvas);
                }
                if (key === 46) e.preventDefault();
                if (textAreaLength === 0) {
                    if (key === 71 && e.shiftKey && (e.ctrlKey || e.metaKey)) {
                        handleUngroup(selectionRef.current, canvas);
                        e.preventDefault();
                    } else if (
                        key === 90 &&
                        e.shiftKey &&
                        (e.ctrlKey || e.metaKey)
                    ) {
                        handleRedo();
                        e.preventDefault();
                    } else if (key === 90 && (e.ctrlKey || e.metaKey)) {
                        console.log("Undo:", key);
                        handleUndo();
                        e.preventDefault();
                    } else if (key === 86 && (e.ctrlKey || e.metaKey)) {
                        setActiveTool("select");
                    } else if (key === 71 && (e.ctrlKey || e.metaKey)) {
                        handleGroup(selectionRef.current, canvas);
                        e.preventDefault();
                    } else if (key === 68 && (e.ctrlKey || e.metaKey)) {
                        console.log(
                            "selectionRef.current:",
                            selectionRef.current
                        );

                        handleDuplicate(selectionRef.current, canvas);
                        e.preventDefault();
                    } else if (key === 219 && (e.ctrlKey || e.metaKey)) {
                        handleBringBack(selectionRef.current, canvas);
                        e.preventDefault();
                    } else if (key === 221 && (e.ctrlKey || e.metaKey)) {
                        handleBringFwd(selectionRef.current, canvas);
                        e.preventDefault();
                    }
                }
            };

            const mouseZoom = (e) => {
                if (!initCropper) {
                    return zoomWithMouse(e, canvas, setZoom, applyZoom);
                }
            };

            const saveHistory = () => {
                const updatedHistory = [...history.states];

                // if any action happens after undo, clear all (redo) actions after current state
                if (history.index < history.states.length - 1)
                    updatedHistory.splice(history.index + 1);

                // add current state to history
                updatedHistory.push(canvas.toJSON());
                if (updatedHistory.length > maxHistory) updatedHistory.shift();

                const historyObj = {
                    index: updatedHistory.length - 1,
                    states: updatedHistory
                };
                setHistory(historyObj);
                modifyCanvasStatus(true, historyObj);
                setHasAnyChange(true);
            };

            document.addEventListener("keydown", keyShortCuts);
            document.addEventListener("wheel", mouseZoom, { passive: false });
            canvas.on("object:modified", saveHistory);
            canvas.on("path:created", saveHistory);

            // cleanup
            return () => {
                document.removeEventListener("keydown", keyShortCuts);
                document.removeEventListener("wheel", mouseZoom);
                canvas.off("object:modified", saveHistory);
                canvas.off("path:created", saveHistory);
            };
        }, [canvas, history]);

        useEffect(() => {
            if (canvas) {
                window.globalColor = drawColor;
                canvas.freeDrawingBrush.color = drawColor;
            }
        }, [drawColor]);

        useEffect(() => {
            if (activeTool !== "crop" && initCropper) {
                closeCrop();
            }
        }, [activeTool]);

        useEffect(() => {
            droppedImage.map((file) => addImageOnCanvas(file, "fileReader"));
        }, [droppedImage]);

        useImperativeHandle(ref, () => ({
            // console.log('Hi imparative*************************88888')
            exportCanvas(bool, isModified) {
                return downloadAllCanvas(bool, isModified);
            },
            toggleCanvasModification(canvasId) {
                return toggleCanvasModifiedFlag(canvasId);
            },
            changeDesignToolTabName(value) {
                setTmpTabName(value);
            },
            getHistoryState() {
                return history;
            }
        }));

        const toggleCropModal = async () => {
            setActiveDropdown("");
            const imageObject = canvas?.getActiveObject();
            setSelectedObj(imageObject);
            if (imageObject && isImage(imageObject) === true) {
                const lowerCanvas = document.getElementById(
                    canvas.getElement().id
                ).nextElementSibling;
                lowerCanvas.setAttribute("style", "opacity: 0");

                const image = document.getElementById(canvas.getElement().id);

                initCropper = new Cropper(image, {
                    background: false,
                    autoCrop: false,
                    zoomable: false,
                    zoomOnTouch: false,
                    zoomOnWheel: false
                });
                const canvasElements = document
                    .getElementById("parent_" + canvas.getElement().id)
                    .querySelector(".upper-canvas");
                canvasElements.classList.add("hide-upper-canvas");

                function handleCropStart() {
                    const canvasElement = document
                        .getElementById("parent_" + canvas.getElement().id)
                        .querySelector(".cropper-drag-box");
                    canvasElement.setAttribute(
                        "style",
                        "background-color: unset"
                    );
                }

                function handleCropEnd() {
                    window.removeEventListener("cropend", handleCropEnd);
                    window.removeEventListener("touchend", handleCropEnd);
                    window.removeEventListener("cropstart", handleCropStart);
                    window.removeEventListener("touchstart", handleCropStart);
                }

                window.addEventListener("cropend", handleCropEnd);
                window.addEventListener("touchend", handleCropEnd);
                window.addEventListener("cropstart", handleCropStart);
                window.addEventListener("touchstart", handleCropStart);

                await setActiveTool("crop");
            }
        };

        const modifyCanvasStatus = (value, historyObj) => {
            if (activeCanvasId) {
                const tmpCanvasList = { ...canvasList };
                tmpCanvasList[activeCanvasId].isModified = value;
                tmpCanvasList[activeCanvasId].canvasHistory = historyObj;
                tmpCanvasList[activeCanvasId].canvasData = canvas;
                setCanvasList(tmpCanvasList);
                canvasRef.current = tmpCanvasList;
            }
        };

        const toggleCanvasModifiedFlag = (canvasId, isModified = true) => {
            if (canvasId) {
                const tmpCanvasList = { ...canvasList };
                tmpCanvasList[canvasId].isModified = isModified;
                setCanvasList(tmpCanvasList);
                canvasRef.current = tmpCanvasList;
            }
        };

        const addNewCanvas = (canvasName) => {
            setCanvas(undefined);
            const newElement = {};
            const newCanvasId = generateCanvasId();
            newElement[newCanvasId] = {
                canvasName: canvasName,
                canvasData: {},
                serial: newCanvasId,
                canvasLeft: 0,
                canvasUsedWidth: 0,
                isModified: false,
                canvasHistory: { index: null, states: [] }
            };
            const tmpCanvasList = { ...canvasRef.current };
            setCanvasList({ ...tmpCanvasList, ...newElement });
            canvasRef.current = { ...tmpCanvasList, ...newElement };
            // setActiveTool('select')
            setCanvasCount(newCanvasId);
        };

        const saveTextOnOutsideHover = () => {
            if (!canvas?.getActiveObject()) return;
            if (
                canvas?.getActiveObject()?.isEditing &&
                canvas?.getActiveObject()?.type === "CustomTextbox"
            ) {
                canvas?.discardActiveObject()?.requestRenderAll();
                canvas.fire("object:modified");
            }
        };

        const changeCanvas = async (selectedCanvas, canvasId) => {
            saveTextOnOutsideHover(canvasId);
            if (activeCanvasId !== canvasId) {
                await setPrevCanvasId(activeCanvasId);

                const tmpCanvasList = { ...canvasRef.current };
                const activeCanvas = tmpCanvasList[activeCanvasId];

                if (
                    activeCanvasId !== undefined &&
                    activeCanvas !== undefined
                ) {
                    activeCanvas.canvasHistory = history;
                }

                tmpCanvasList[canvasId] = {
                    ...canvasList[canvasId],
                    canvasData: selectedCanvas,
                    canvasHistory: canvasList[canvasId].canvasHistory
                };

                canvasRef.current = tmpCanvasList;
                await Promise.all([
                    setCanvasList(tmpCanvasList),
                    setCanvas(selectedCanvas),
                    setActiveCanvasId(canvasId),
                    setHistory(canvasList[canvasId].canvasHistory)
                ]);
            }
        };

        const removeCanvas = async (canvasId) => {
            console.log("canvasId:", canvasId);
            console.log("artBoardWiseImage:", artBoardWiseImage);
            setActiveCanvasId(undefined);
            setCanvas(null);
            const listOfCanvas = { ...canvasRef.current };
            delete artBoardWiseImage[canvasId];
            delete listOfCanvas[canvasId];
            setCanvasList(listOfCanvas);
            canvasRef.current = listOfCanvas;
            setRemoveCanvasId([...removedCanvasIds, canvasId]);
            if (removeArtBoard) {
                removeArtBoard(canvasId);
            }
            setOpenModal(false);
        };

        const removeCanvasTemporary = async (canvasId) => {
            setActiveCanvasId(undefined);
            setCanvas(null);
            const listOfCanvas = { ...canvasRef.current };
            delete listOfCanvas[canvasId];
            setCanvasList(listOfCanvas);
            canvasRef.current = listOfCanvas;
            if (removeArtBoard) {
                removeArtBoard(canvasId);
            }
        };

        const changeCanvasName = (canvasName, canvasId) => {
            if (canvasName) {
                const tmpCanvasList = { ...canvasList };
                tmpCanvasList[canvasId].canvasName = canvasName;
                tmpCanvasList[canvasId].isModified = true;
                setCanvasList(tmpCanvasList);
                canvasRef.current = tmpCanvasList;
                canvas?.discardActiveObject()?.requestRenderAll();
                canvas.fire("object:modified");
            }
        };

        const closeCrop = () => {
            initCropper.destroy();
            const upperCanvasElements = document
                .getElementById("parent_" + canvas.getElement().id)
                .querySelector(".upper-canvas");
            upperCanvasElements.classList.remove("hide-upper-canvas");
            upperCanvasElements.classList.add("show-upper-canvas");
            setActiveTool("select");
            initCropper = undefined;
        };

        const cropImage = () => {
            const croppedImageData = initCropper
                .getCroppedCanvas({
                    imageSmoothingEnabled: true,
                    imageSmoothingQuality: "high"
                })
                .toDataURL("image/jpeg", 1);
            canvas.remove(selectedObj);
            const cropAxis = initCropper.getCropBoxData();
            fabric.Image.fromURL(
                croppedImageData,
                function(img) {
                    img.set({ left: cropAxis.left, top: cropAxis.top });
                    canvas.add(img);
                    canvas.fire("object:modified");
                },
                { crossOrigin: "Anonymous" }
            );
            closeCrop();
        };

        const downloadAllCanvas = (
            saveCanvas = false,
            saveIsModified = false
        ) => {
            const listOfCanvas = { ...canvasRef.current };
            const postData = {};

            if (!saveCanvas) {
                for (const item in listOfCanvas) {
                    if (!removedCanvasIds.includes(item)) {
                        const canvasBoard = listOfCanvas[item];
                        if (
                            Object.keys(canvasBoard.canvasData).length > 0 &&
                            canvasBoard.isModified === true &&
                            canvasBoard.canvasData._objects.length > 0
                        ) {
                            const fabricC = new fabric.Canvas("hidden-canvas");
                            const clone = Object.assign(
                                {},
                                canvasBoard.canvasData
                            );
                            clone.width = CANVAS_WIDTH;
                            clone.height = CANVAS_HEIGHT;
                            fabricC.loadFromJSON(clone);
                            fabricC.setZoom(1);
                            postData[item] = {
                                isModified: canvasBoard.isModified,
                                canvasId: item,
                                serial: canvasBoard.serial,
                                canvasName: canvasBoard.canvasName,
                                canvasString: fabricC.toDataURL({
                                    format: "jpeg"
                                }),
                                canvasData: listOfCanvas[item]
                            };
                            listOfCanvas[item].isModified = saveIsModified;
                        }
                    }
                }
                setCanvasList(listOfCanvas);
                canvasRef.current = listOfCanvas;
            } else {
                for (const item in listOfCanvas) {
                    if (!removedCanvasIds.includes(item)) {
                        const canvasBoard = listOfCanvas[item];
                        if (
                            Object.keys(canvasBoard.canvasData).length > 0 &&
                            canvasBoard.canvasData._objects.length > 0
                        ) {
                            const fabricC = new fabric.Canvas("hidden-canvas");
                            const clone = Object.assign(
                                {},
                                canvasBoard.canvasData
                            );
                            clone.width = CANVAS_WIDTH;
                            clone.height = CANVAS_HEIGHT;
                            fabricC.loadFromJSON(clone);
                            fabricC.setZoom(1);
                            postData[item] = {
                                canvasId: item,
                                serial: canvasBoard.serial,
                                canvasName: canvasBoard.canvasName,
                                canvasString: fabricC.toDataURL({
                                    format: "jpeg"
                                }),
                                canvasData: listOfCanvas[item]
                            };
                            listOfCanvas[item].isModified = saveIsModified;
                        }
                    }
                }
                setCanvasList(listOfCanvas);
                canvasRef.current = listOfCanvas;
            }
            return postData;
        };

        const renderToolPanel = () => {
            return (
                <ToolPanel visible>
                    <UploadSettings
                        removeCanvasTemporary={removeCanvasTemporary}
                        canvasList={canvasList}
                        setCanvasList={setCanvasList}
                        canvas={canvas}
                        imageList={imageList}
                        pinnedImages={pinnedImages}
                        docList={docList}
                        setDocList={setDocList}
                        addImageOnCanvas={addImageOnCanvas}
                        removeDocumentById={removeDocumentById}
                        uploadDocument={uploadDocument}
                        setImageList={setImageList}
                        activeSelection={activeSelection}
                        activeTool={activeTool}
                        drawColor={drawColor}
                        setDrawColor={setDrawColor}
                        setZoom={setZoom}
                        zoom={zoom}
                        isMarkToolRelease={isMarkToolRelease}
                        setActiveCanvasId={setActiveCanvasId}
                        reArrangeCanvasHandler={reArrangeCanvasHandler}
                        onSetActiveTab={onSetActiveTab}
                        tmpTabName={tmpTabName}
                        //    pasteArtBoardData={pasteArtBoardData}
                    />
                </ToolPanel>
            );
        };

        const changeCanvasLeftSpace = (canvasId, value, canvasUsedWidth) => {
            if (canvasId) {
                const tmpCanvasList = { ...canvasList };
                tmpCanvasList[canvasId].canvasLeft = value;
                tmpCanvasList[canvasId].canvasUsedWidth = canvasUsedWidth;
                setCanvasList(tmpCanvasList);
                canvasRef.current = tmpCanvasList;
            }
        };

        const addImageOnCanvas = (item, type = "url") => {
            const canvasId = canvas.getElement().id;
            const canvasData = canvasList[canvasId];
            let canvasLeft = canvasData.canvasLeft;
            const canvasUsedWidth = canvasData.canvasUsedWidth;
            const width = canvas.getWidth();
            let leftValue;

            if (canvasUsedWidth === 0) {
                leftValue = 80;
            } else if (width - canvasUsedWidth > 680) {
                leftValue = 80 + canvasUsedWidth + 400;
            } else {
                leftValue = 80;
            }

            changeCanvasLeftSpace(canvasId, (canvasLeft += 500), leftValue);

            const addFabricImage = (img) => {
                img.set({ left: leftValue });
                img.scaleToHeight(400);
                img.scaleToWidth(400);
                canvas.centerObjectV(img);
                canvas.add(img);
            };

            if (type === "url") {
                fabric.Image.fromURL(
                    `${item.docUrl}?x-${
                        Math.floor(Math.random() * 1000000000) + 1
                    }=html`,
                    addFabricImage,
                    { crossOrigin: "Anonymous" }
                );
            } else {
                const reader = new FileReader();
                reader.onload = function(event) {
                    const imgObj = new Image();
                    imgObj.src = event.target.result;
                    imgObj.onload = function() {
                        const image = new fabric.Image(imgObj);
                        addFabricImage(image);
                    };
                };
                reader.readAsDataURL(item);
            }

            canvas.requestRenderAll();
            canvas.calcOffset();
            canvas.fire("object:modified");
        };

        const handleUndo = () => {
            undo(canvas, history, setHistory);
            setHasAnyChange(true);
        };

        const handleRedo = () => {
            redo(canvas, history, setHistory);
            setHasAnyChange(true);
        };

        const changeActiveTool = (toolName, isDropdown) => {
            setActiveTool(toolName);
            removeUnwantedText(canvas);
            setIsActiveDropdown(isDropdown);
            if (!isDropdown) {
                //  console.log('isDropdown')
                setActiveDropdown("");
            }
        };

        return (
            <div id="nitex__app">
                <Toolbar>
                    {/* <ToolButton
                        toolType='select'
                        activeTool={activeTool}
                        changeActiveTool={changeActiveTool}
                        canvas={canvas}
                        icon={<IconCursor />}
                        title='Select/move object'
                        shortCut='V'
                        classN=''
                        requiredTools={requiredTools}
                    /> */}

                    {isToolRequired("select", requiredTools) && (
                        <Button
                            name="select"
                            className={activeTool === "select" ? "active" : ""}
                            title={translator("Select/move object")}
                            shortCut="V"
                            handleClick={() => {
                                canvas?.discardActiveObject();
                                changeActiveTool("select", false);
                            }}
                        >
                            <IconCursor />
                        </Button>
                    )}
                    {isToolRequired("shape", requiredTools) && (
                        <div className="parent-div multi-icon">
                            <Button
                                name="select"
                                className={
                                    activeDropdown === "shapes" ? "active" : ""
                                }
                                title={translator("SHAPES")}
                                //   handleClick={() => changeActiveTool('shapes')}
                                handleClick={() => {
                                    setActiveDropdown("shapes");
                                    changeActiveTool(activeShape, true);
                                }}
                            >
                                {Icons.getSelectedIcon(activeShape)}
                            </Button>
                            <div className="drop-down-icon">
                                <DropIcon />
                            </div>
                            {activeDropdown === "shapes" &&
                                isActiveDropdown && (
                                    <Shapes
                                        canvas={canvas}
                                        setActiveShape={setActiveShape}
                                        setActiveTool={setActiveTool}
                                        activeTool={activeTool}
                                        changeActiveTool={changeActiveTool}
                                        activeDropdown={activeDropdown}
                                        setIsActiveDropdown={
                                            setIsActiveDropdown
                                        }
                                    />
                                )}
                        </div>
                    )}
                    {isToolRequired("shape", requiredTools) && (
                        <div className="parent-div multi-icon">
                            <Button
                                name="select"
                                className={
                                    activeDropdown === "lines" ? "active" : ""
                                }
                                title="Lines"
                                // handleClick={() => {
                                //     changeActiveTool('lines')
                                // }}
                                handleClick={() => {
                                    setActiveDropdown("lines");
                                    changeActiveTool(activeLine, true);
                                }}
                            >
                                {Icons.getSelectedLineIcon(activeLine)}
                            </Button>
                            <div className="drop-down-icon">
                                <DropIcon />
                            </div>
                            {activeDropdown === "lines" && isActiveDropdown && (
                                <Shapes
                                    canvas={canvas}
                                    setActiveLine={setActiveLine}
                                    setActiveTool={setActiveTool}
                                    activeTool={activeTool}
                                    changeActiveTool={changeActiveTool}
                                    activeDropdown={activeDropdown}
                                    setIsActiveDropdown={setIsActiveDropdown}
                                />
                            )}
                        </div>
                    )}

                    {isToolRequired("curves", requiredTools) && (
                        <Button
                            className={activeTool === "path" ? "active" : ""}
                            name="path"
                            title="Pen"
                            handleClick={() => changeActiveTool("path", false)}
                        >
                            <IconPath />
                        </Button>
                    )}
                    {isToolRequired("draw", requiredTools) && (
                        <Button
                            className={activeTool === "draw" ? "active" : ""}
                            name="draw"
                            title="Pencil"
                            handleClick={() => changeActiveTool("draw", false)}
                        >
                            <IconBrush />
                        </Button>
                    )}
                    {isToolRequired("textBox", requiredTools) && (
                        <Button
                            className={activeTool === "textbox" ? "active" : ""}
                            name="textbox"
                            title="Text"
                            handleClick={() =>
                                changeActiveTool("textbox", false)
                            }
                        >
                            <IconText />
                        </Button>
                    )}
                    {isToolRequired("crop", requiredTools) && (
                        <div className="crop-parent-div">
                            <Button
                                name="select"
                                className={
                                    activeTool === "crop" ? "active" : ""
                                }
                                title={translator("Crop options")}
                                handleClick={toggleCropModal}
                            >
                                <IconCrop />
                            </Button>
                            {activeTool === "crop" && !activeSelection && (
                                <CropOption
                                    handleCrop={cropImage}
                                    cancelCrop={closeCrop}
                                />
                            )}
                        </div>
                    )}
                    {isToolRequired("multipleCanvas", requiredTools) && (
                        <div className="parent-div">
                            <Button
                                name="multipleCanvas"
                                className={
                                    activeTool === "multipleCanvas"
                                        ? "active"
                                        : ""
                                }
                                title="Artboard"
                                handleClick={() => {
                                    changeActiveTool("multipleCanvas", false);
                                }}
                            >
                                <IconFrame />
                            </Button>
                            {activeTool === "multipleCanvas" &&
                                !activeSelection && (
                                    <FramePanel
                                        addNewCanvas={addNewCanvas}
                                        setActiveTool={setActiveTool}
                                    />
                                )}
                        </div>
                    )}
                    {isToolRequired("comment", requiredTools) && (
                        <div className="crop-parent-div">
                            <Button
                                name="select"
                                className={
                                    activeTool === "mark" ||
                                    activeTool === "singlePointMark"
                                        ? "active"
                                        : ""
                                }
                                title={translator("comment")}
                                handleClick={() => {
                                    changeActiveTool("singlePointMark", false);
                                }}
                            >
                                {Icons.getCommentSelectedIcon(
                                    activeCommentType
                                )}
                            </Button>
                        </div>
                    )}
                </Toolbar>
                {renderToolPanel()}
                <div
                    className="canvas-content-wrapper"
                    style={{ paddingTop: "20px" }}
                >
                    {Object.keys(canvasList).map((item, index) => {
                        return (
                            <FabricCanvas
                                key={item}
                                uniqueKey={canvasList[item].key}
                                canvas={canvas}
                                setCanvas={changeCanvas}
                                setActiveSelection={setActiveSelection}
                                setHistory={setHistory}
                                activeTool={activeTool}
                                idName={item}
                                removeCanvas={() => setOpenModal(true)}
                                canvasTitle={canvasList[item].canvasName}
                                canvasImages={
                                    artBoardWiseImage?.[item]?.imageList
                                }
                                changeCanvasName={changeCanvasName}
                                setIsMarkToolRelease={setIsMarkToolRelease}
                                imageList={imageList}
                                uploadDocument={uploadDocument}
                                setDroppedImage={setDroppedImage}
                                setActiveTool={setActiveTool}
                                setImageList={setImageList}
                                listOfCanvasData={listOfCanvasData}
                                handleUndo={handleUndo}
                                handleRedo={handleRedo}
                                memberList={memberList}
                                addNewPost={addNewPost}
                                isMarkToolRelease={isMarkToolRelease}
                                onHide={setIsMarkToolRelease}
                                userInfo={userInfo}
                                activeCanvasId={activeCanvasId}
                                commentCanvasId={commentCanvasId}
                                setCommentCanvasId={setCommentCanvasId}
                                drawColor={drawColor}
                                listOfComments={listOfComments}
                                setCommentPositionNumber={
                                    setCommentPositionNumber
                                }
                                commentPositionNumber={commentPositionNumber}
                                resetCanvas={setCanvas}
                                setZoom={setZoom}
                            />
                        );
                    })}
                </div>
                <Confirmation
                    title="Are you sure?"
                    handleClose={() => setOpenModal(false)}
                    handleSubmit={removeCanvas}
                    activeCanvasId={activeCanvasId}
                    openModal={openModal}
                />
            </div>
        );
    }
);

export default NitexEditor;
